import React, { useState, useMemo, useEffect } from "react";
import { TableCell, TableRow } from "@material-ui/core";
import {
  ModalDeleteConfirm,
  ModalDefaultError,
  IconButtonDatatable,
  TableCellDefault,
  TableWrapper,
} from "App/Component/ui";

import { stableSort, getComparator } from "App/Component/ui/datatable/utils";
import {
  FormTabPerusahaan,
  headCells,
  STYLE_TAB_PERUSAHAAN,
  RESET_STATE_PERUSAHAAN,
  getAllCompany,
  deleteCompanyById,
} from "./ui";

import { useSearchDatatables } from "App/hooks";
import { scrollToTop } from "App/utils/helpers";
import { PencilIcon, TrashIcon } from "App/Assets";

let PageSize = 10;

export default function TabAsuransi() {
  const classes = STYLE_TAB_PERUSAHAAN();
  const [order, setOrder] = useState("desc");
  const [orderBy, setOrderBy] = useState("name");
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(PageSize);

  const [showModalDefaultError, setShowModalDefaultError] = useState(false);
  const [showModalDeleteConfirm, setShowModalDeleteConfirm] = useState(false);

  const [q, setQ] = useState("");
  const [rows, setRows] = useState([]);

  const [formData, setFormData] = useState(RESET_STATE_PERUSAHAAN);

  const [run, setRun] = useState(false);
  const { data, length } = useSearchDatatables(rows, q, ["name", "code"]);

  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === "asc";
    setOrder(isAsc ? "desc" : "asc");
    setOrderBy(property);
  };

  useEffect(() => {
    (async () => {
      const res = await getAllCompany();
      if (res) {
        setRows(res);
      } else {
        setShowModalDefaultError(true);
      }
    })();
  }, [run]);

  useMemo(() => {
    const firstPageIndex = (page - 1) * PageSize;
    const lastPageIndex = firstPageIndex + PageSize;
    return data.slice(firstPageIndex, lastPageIndex);
  }, [page, data]);

  const setVal = (row) => {
    return setFormData({
      id: row?.id,
      name: row?.name,
      address: row?.address,
      phone: row?.phone,
      contactperson: row?.contactperson,
      cpaddress: row?.cpaddress,
      cpemail: row?.cpemail,
      cpphone: row?.cpphone,
      cpmobilephone: row?.cpmobilephone,
      business: row?.business,
      status: row?.status ? 1 : 0,
      remark: row?.remark,
      nama_virtual_account: row?.nama_virtual_account,
      no_virtual_account: row?.no_virtual_account,
      nama_bank: row?.nama_bank,
    });
  };

  return (
    <div className={classes.root}>
      {showModalDefaultError && (
        <ModalDefaultError
          setShowModalDefaultError={() => setShowModalDefaultError(true)}
        />
      )}

      {showModalDeleteConfirm && (
        <ModalDeleteConfirm
          confirmHandle={() =>
            deleteCompanyById(
              formData.id,
              () => setRun(!run),
              setShowModalDeleteConfirm,
              setFormData
            )
          }
          setShowModalDeleteConfirm={() => setShowModalDeleteConfirm(false)}
        />
      )}

      <FormTabPerusahaan
        formData={formData}
        setFormData={setFormData}
        run={() => setRun(!run)}
      />

      {/* <div className='mt-2'>
        <Paper className={classes.paper}>
          <FormFilterPerusahaan />

          <Grid
            container
            direction='row'
            justifyContent='flex-end'
            alignItems='center'>
            <MasterButton
              name={"Export"}
              outline={false}
              color={"warning"}
              type={"submit"}
              size={"md"}
              className='mt-2 mb-1'
            />
          </Grid>

          <TableContainer className='custom-scrollbar'>
            <Table
              className={classes.table}
              aria-labelledby='tableTitle'
              size={"medium"}
              aria-label='enhanced table'>
              <TableHeader
                classes={classes}
                order={order}
                orderBy={orderBy}
                onRequestSort={handleRequestSort}
                rowCount={length}
                headCells={headCells}
              />
              <TableBody>
                {stableSort(data, getComparator(order, orderBy))
                  .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                  .map((row, index) => {
                    return (
                      <TableRow
                        hover
                        tabIndex={-1}
                        key={index}
                        style={{
                          backgroundColor:
                            index % 2 === 0 ? "transparent" : "#fff",
                        }}>
                        <TableCell
                          component='th'
                          scope='row'
                          padding='none'
                          align='center'>
                          {index + 1}
                        </TableCell>

                        <TableCell
                          component='th'
                          scope='row'
                          padding='none'
                          align='center'>
                          <div
                            style={{
                              display: "flex",
                              alignItems: "center",
                              gap: "7px",
                            }}>
                            <IconButtonDatatable
                              onClick={() => {
                                setVal(row);
                                scrollToTop();
                              }}>
                              <PencilIcon />
                            </IconButtonDatatable>

                            <IconButtonDatatable
                              onClick={() => {
                                setFormData({
                                  ...formData,
                                  id: row?.id,
                                });
                                setShowModalDeleteConfirm(
                                  !showModalDeleteConfirm
                                );
                              }}>
                              <TrashIcon />
                            </IconButtonDatatable>
                          </div>
                        </TableCell>

                        <TableCell align='left'>{row?.id}</TableCell>
                        <TableCell align='left'>{row?.name}</TableCell>
                        <TableCell align='left'>{row?.address}</TableCell>
                        <TableCell align='left'>{row?.phone}</TableCell>
                        <TableCell align='left'>{row?.contactperson}</TableCell>
                        <TableCell align='left'>{row?.cpphone}</TableCell>
                        <TableCellDefault row={row} />
                      </TableRow>
                    );
                  })}
                {rows.length === 0 && (
                  <TableRow>
                    <TableCell align='center' colSpan={headCells.length}>
                      Tidak ada data
                    </TableCell>
                  </TableRow>
                )}
              </TableBody>
            </Table>
          </TableContainer>

          <DatatablesFooter
            page={page}
            length={length}
            rowsPerPage={rowsPerPage}
            selectRows={[10, 20]}
            onPageChange={(page) => setPage(page - 1)}
            onSelectChange={(e) => setRowsPerPage(e.target.value)}
          />
        </Paper>
      </div> */}

      <div className='mt-1'>
        <TableWrapper
          title='Daftar Perusahaan'
          setQ={setQ}
          // clickAddButton={() => clickAdd()}
          withAddButton={false}
          withExportButton={false}
          order={order}
          orderBy={orderBy}
          handleRequestSort={handleRequestSort}
          length={length}
          rows={rows}
          headCells={headCells}
          page={page}
          setPage={setPage}
          rowsPerPage={rowsPerPage}
          setRowsPerPage={setRowsPerPage}>
          {stableSort(data, getComparator(order, orderBy))
            .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
            .map((row, index) => {
              return (
                <TableRow
                  hover
                  tabIndex={-1}
                  key={index}
                  style={{
                    backgroundColor: index % 2 === 0 ? "transparent" : "#fff",
                  }}>
                  <TableCell
                    component='th'
                    scope='row'
                    padding='none'
                    align='center'>
                    {index + 1}
                  </TableCell>

                  <TableCell
                    component='th'
                    scope='row'
                    padding='none'
                    align='center'>
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: "7px",
                      }}>
                      <IconButtonDatatable
                        onClick={() => {
                          setVal(row);
                          scrollToTop();
                        }}>
                        <PencilIcon />
                      </IconButtonDatatable>

                      <IconButtonDatatable
                        onClick={() => {
                          setFormData({
                            ...formData,
                            id: row?.id,
                          });
                          setShowModalDeleteConfirm(!showModalDeleteConfirm);
                        }}>
                        <TrashIcon />
                      </IconButtonDatatable>
                    </div>
                  </TableCell>

                  <TableCell align='left'>{row?.id}</TableCell>
                  <TableCell align='left'>{row?.name}</TableCell>
                  <TableCell align='left'>{row?.nama_bank}</TableCell>
                  <TableCell align='left'>{row?.no_virtual_account}</TableCell>
                  <TableCell align='left'>{row?.nama_virtual_account}</TableCell>
                  <TableCell align='left'>{row?.address}</TableCell>
                  <TableCell align='left'>{row?.phone}</TableCell>
                  <TableCell align='left'>{row?.contactperson}</TableCell>
                  <TableCell align='left'>{row?.cpphone}</TableCell>
                  <TableCellDefault row={row} />
                </TableRow>
              );
            })}
        </TableWrapper>
      </div>
    </div>
  );
}
